"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _ApplyAndCancelButtons = require("../sharedComponents/ApplyAndCancelButtons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MultiSelectField = function MultiSelectField(_ref) {
  var valuesToRender = _ref.valuesToRender,
    classes = _ref.classes,
    values = _ref.values,
    setValues = _ref.setValues,
    selectProps = _ref.selectProps;
  var previousValues = (0, _react.useRef)(values);
  var handleAddValue = (0, _react.useCallback)(function (event) {
    setValues(event.target.value);
  }, [setValues]);
  var handleApplyValues = function handleApplyValues() {
    previousValues.current = values;
    closePopup();
  };
  var handleCancelValues = function handleCancelValues() {
    setValues(previousValues.current);
    closePopup();
  };
  var closePopup = function closePopup() {
    document.getElementById("menu-select_values").firstChild.click();
  };
  return /*#__PURE__*/_react.default.createElement(_core.Select, _extends({
    name: "select_values",
    className: classes.selectField,
    fullWidth: true,
    SelectDisplayProps: {
      style: {
        whiteSpace: "pre-wrap"
      }
    },
    variant: "outlined",
    value: values,
    onChange: handleAddValue,
    onClose: handleApplyValues,
    renderValue: function renderValue(selectedValues) {
      return selectedValues.map(function (value) {
        return value;
      }).join(", ");
    },
    MenuProps: {
      MenuListProps: {
        className: classes.menuList
      }
    },
    multiple: true
  }, selectProps), valuesToRender.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: value,
      value: value
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: values.includes(value)
    }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      primary: label
    }));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_ApplyAndCancelButtons.ApplyAndCancelButtons, {
    onCancel: handleCancelValues,
    onApply: handleApplyValues,
    className: classes.bottomButtonsWrapper,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  })));
};
exports.MultiSelectField = MultiSelectField;